import { Phase2 } from "@/components/PageHeader";
import { Award, FolderOpen, Calendar } from "lucide-react";

export function CPD() {
  return <Phase2 icon={Award} title="CPD & certificates" note="Downloadable CPD records and PDF certificates with verification references are next up. Course completion and CPD hours are already tracked in the Classroom." />;
}

export function Resources_UNUSED() { return null; }

export function CalendarPage() {
  return <Phase2 icon={Calendar} title="Calendar & events" note="Live sessions, webinars and CPD events will appear here in a later phase." />;
}
